var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer--link-list"},[(_vm.heading)?_c('span',{staticClass:"title d-block mb-3"},[_vm._v(_vm._s(_vm.heading))]):_vm._e(),(_vm.content)?_c('markdown',{attrs:{"text":_vm.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }